<template>
    <div id="main">
        <HeaderNav :isMobile="isMobile" :cdnPrefix="cdnPrefix"></HeaderNav>

        <!-- 背景视频 -->
        <div v-if="!isMobile" class="video-index-bg">
            <div class="video-mask"></div>
            <video class="video-index" loop muted currentTime="0" :poster="cdnPrefix+'/imgs/bg-poster.png'">
                <source :src="cdnPrefix + '/P20N.mp4'" type="video/mp4" />
            </video>
        </div>

        <Index :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Index>

        <Video :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Video>

        <Generals :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Generals>

        <StrategicMap :isMobile="isMobile" :cdnPrefix="cdnPrefix"></StrategicMap>

        <Description :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Description>

        <Footer :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Footer>

        <div v-if="isMobile" class="new-fb-box">
            <router-link class="new-btn" to="/secondary">{{$t("phonetext.new")}}</router-link>
            <a
                v-if="lang=='zh-CN'"
                class="fb-btn"
                href="https://www.facebook.com/zgbwu/"
            >{{$t("phonetext.fb")}}</a>
            <a
                v-if="lang=='ja'"
                class="fb-btn"
                href="https://twitter.com/sengokufubu"
            >{{$t("phonetext.fb")}}</a>
            <a
                v-if="lang=='en'"
                class="fb-btn"
                href="https://www.facebook.com/sengokufubu.en/"
            >{{$t("phonetext.fb")}}</a>
            <a
                v-if="lang=='th'"
                class="fb-btn"
                href="https://www.facebook.com/sengokufubu.th/"
            >{{$t("phonetext.fb")}}</a>
        </div>
    </div>
</template>

<script>
import HeaderNav from "./HeaderNav.vue";
import Index from "./Index.vue";
import Video from "./Video.vue";
import Generals from "./Generals.vue";
import StrategicMap from "./StrategicMap.vue";
import Description from "./Description.vue";
import Footer from "./Footer.vue";

export default {
    name: "Main",
    components: {
        HeaderNav,
        Index,
        Video,
        Generals,
        StrategicMap,
        Description,
        Footer
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            lang: window.localStorage.getItem("localeLanguage")
        };
    },
    watch: {},
    mounted() {
        // 播放背景视频
        if (document.body.offsetWidth > 768) {
            document.getElementById("main").scrollTo(0, 0);
            setTimeout(function() {
                if (screen.availWidth < 980) {
                    return false;
                }
                let elem = document.getElementsByClassName("video-index")[0];
                elem.play();
            }, 200);
        }
    },
    methods: {}
};
</script>

<style lang="scss">
#main {
    height: 100%;
    overflow-y: auto;
    .video-index-bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -999;
        background: rgba(155, 155, 155, 0.2);
        .video-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            background: rgba(0, 0, 0, 0.5);
        }
        .video-index {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
    }
}
// 适配小屏
@media screen and (max-width: 768px) {
    #main {
        height: auto;
        padding: 40px 0;
        background: url($cdnPrefix+"/imgs/bgphone-p20n.png")
            center bottom no-repeat;
        background-size: 100% 100%;
        .new-fb-box {
            position: fixed;
            bottom: 0;
            z-index: 1000;
            width: 100%;
            height: 45px;
            display: flex;
            justify-content: space-around;
            background: url($cdnPrefix+"/imgs/bgphone-new-fb.png")
                center top no-repeat;
            background-size: 100% auto;
            .new-btn,
            .fb-btn {
                line-height: 45px;
                cursor: pointer;
                color: #fff;
                font-weight: bold;
                font-size: 18px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue